<template>
  <el-select ref="myOption" class="mySelect" multiple filterable
             v-model="accu_dimension"
             placeholder="请选择"
             collapse-tags
             @visible-change="v => visibleChange(v, 'myOption', selectClick)"
  >
    <el-option
        v-for="item in columsdata"
        :key="item.value"
        :label="item.label.slice(0, item.label.lastIndexOf(':'))"
        :value="item.value"
    >
    </el-option>
  </el-select>
</template>

<script>

export default {
  name: "CustomCascader",

  props: ["accuDimension", "colums","loading"],//value和input，形成双向绑定
  data() {
    return {
      columsdata: [],
      temp_accu: [],//汇总纬度已选的（预定义，等待columsdata加载出来才放进到accu_dimension上）
      accu_dimension: [],//汇总纬度已选的
      accu_columns: [],//汇总显示列
      accu_dimension_no_type: [],
      defaultAccuColums:
          [{"value": "client:client_name", "label": "客户:客户名称:varchar", "checked": false}, {
            "value": "date:month",
            "label": "时间:年月:char",
            "checked": false
          }, {"value": "date:quarter", "label": "时间:季度:char", "checked": false}, {
            "value": "date:stat_time",
            "label": "时间:日期:char",
            "checked": false
          }, {"value": "date:week", "label": "时间:周:char", "checked": false}, {
            "value": "date:year",
            "label": "时间:年:char",
            "checked": false
          }, {
            "value": "dept:responsible_p_dept",
            "label": "部门:负责部门(一级部门):varchar",
            "checked": false
          }, {
            "value": "dept:responsible_s_dept",
            "label": "部门:负责部门(最小部门):varchar",
            "checked": false
          }, {
            "value": "member:account_manager",
            "label": "成员:客户经理:varchar",
            "checked": false
          }, {
            "value": "member:project_director",
            "label": "成员:业务经理:varchar",
            "checked": false
          }, {
            "value": "member:project_manager",
            "label": "成员:项目经理:varchar",
            "checked": false
          }, {
            "value": "project:business_type",
            "label": "项目:业务类型:varchar",
            "checked": false
          }, {
            "value": "project:inorout",
            "label": "项目:内外区分:varchar",
            "checked": false
          }, {
            "value": "project:quotation_type",
            "label": "项目:计价类型:varchar",
            "checked": false
          }, {
            "value": "region:client_region",
            "label": "地区:客户地区:varchar",
            "checked": false
          }, {
            "value": "status:project_stage",
            "label": "状态:项目阶段:varchar",
            "checked": false
          }, {
            "value": "status:project_status",
            "label": "状态:执行状态:varchar",
            "checked": false
          }, {"value": "status:settlement_status", "label": "状态:结算状态:varchar", "checked": false}]
    }
  },

  mounted() {
    this.columsdata = this.colums.length ? this.colums : this.defaultAccuColums
    this.temp_accu = this.accuDimension
    this.accu_dimension = [...this.temp_accu]
    // console.log('this.temp_accu', this.temp_accu)
  },

  watch: {
    colums: {
      handler(newVal, oldVal) {
        // console.log('colums change')
        // if (!oldVal.length) {
        this.columsdata = newVal
        this.temp_accu = this.temp_accu ? this.temp_accu : []
        // console.log('this.temp_accu',this.temp_accu)
        this.accu_dimension = [...this.temp_accu]
        // }
      },
      deep: true
    },

    accuDimension(newVal) {
      this.temp_accu = newVal
      // console.log('accuDimension/temp_accu',this.temp_accu)
      this.accu_dimension = [...this.temp_accu]
    },
    /**
     * 更新列表中被选中的列
     */
    accu_dimension: {
      handler(newVal) {
        // console.log('accu_dimension change', newVal)
        //改变+1那个标签为共多少条
        this.$nextTick(() => {
          this.changeTipText()
        })

      },
      deep: true
    }
  },

  methods: {
    /**
     * 为element-ui的Select和Cascader添加弹层底部操作按钮
     * @param visible
     * @param refName  设定的ref名称
     * @param onClick  底部操作按钮点击监听
     */
    visibleChange(visible, refName, onClick) {
      if (visible) {
        const ref = this.$refs[refName];
        let popper = ref.$refs.popper;
        if (popper.$el) popper = popper.$el;
        if (!Array.from(popper.children).some(v => v.className === 'el-cascader-menu__list')) {
          const el = document.createElement('div');
          el.className = 'el-cascader-menu__list';
          el.style = 'border-top: solid 1px #E4E7ED; padding:0; color: #606266;';
          el.innerHTML =
              `<div style="display: flex;padding:0 24px;height:38px;line-height: 38px;height: 60px;align-items: center;justify-content: space-between">
                    <el-button id="search" type="primary" style="width: 124px;font-size: 16px;color: white;border-radius: 2px;height: 36px;background: #429FFF;text-align: center">确认</el-button>
                    <div style="margin-left: 24px;color: #8E93A8;">
                        <span id="clean" class="el-cascader-node__label" style="padding-right: 0px;font-size: 17px;line-height: 17px;">清空</span>
                        <i class="el-icon-delete"></i>
                    </div>
                </div>`;
          popper.appendChild(el);
          el.onclick = (e) => {
            // console.log('e', e.target)
            // 底部按钮的点击事件 点击后想触发的逻辑也可以直接写在这
            if (e.target.id == 'search') {
              if(this.loading){
                this.$message.warning('正在获取汇总列表,请稍后');
                return
              }
              onClick && onClick();
              // 以下代码实现点击后弹层隐藏 不需要可以删掉
              if (ref.toggleDropDownVisible) {
                ref.toggleDropDownVisible(false);
              } else {
                ref.visible = false;
              }
            } else if (e.target.id == 'clean') {
              if(this.loading){
                this.$message.warning('正在获取汇总列表,请稍后');
                return
              }
              this.temp_accu = []
              this.accu_dimension = []
              onClick && onClick();
              // 以下代码实现点击后弹层隐藏 不需要可以删掉
              if (ref.toggleDropDownVisible) {
                ref.toggleDropDownVisible(false);
              } else {
                ref.visible = false;
              }
            }


          };
        }
      } else {
        this.selectBlur()
      }
    },

    /**
     * 大于一条数据之后显示共几条
     */
    changeTipText() {
      let tags = document.querySelectorAll(".mySelect div.el-select__tags span.el-tag.el-tag--info.el-tag--small.el-tag--light")
      // console.log('tags', tags)
      if (tags.length > 1) {
        tags[tags.length - 1].innerText = "共" + this.accu_dimension.length + "个"
      }
    },

    selectClick() {

      this.temp_accu = [...this.accu_dimension]
      this.$emit('accu-dimension-update', this.accu_dimension)
      this.$message.success('选择成功，正在获取汇总列表');
    },

    selectBlur() {
      this.accu_dimension = [...this.temp_accu]
      // console.log("selectBlur")
    },

  },
}
</script>

<style lang="scss">
.mySelect {
  width: 270px;
  //不换行显示
  .el-select__tags {
    flex-wrap: nowrap;
    overflow: hidden;
  }

  .el-tag__close.el-icon-close {
    display: none;
  }

  //输入框宽度
  .el-select__input {
    //max-width: calc(100% - 80px) !important;
  }

  //::v-deep(.el-select-dropdown__list.el-select-dropdown__item) {
  //  padding: 0 20px !important;
  //}

  //没有输入时红色
  //::v-deep(.el-input__inner) {
  //  border-color: #FF4242;
  //  &::placeholder {
  //    color: #FF4242;
  //    font-size: 14px;
  //    font-family: PingFang SC;
  //    line-height: 14px;
  //    font-weight: 400;
  //  }
  //}
  //
  ////箭头红色
  //::v-deep(.el-select__caret.el-input__icon.el-icon-arrow-up){
  //  color: #FF4242;
  //}
}

.myCheckbox {
  width: 100%;
}

.childItem {
  display: flex;
  align-items: center;
  height: 34px;
  line-height: 34px;
  padding: 0 20px;
  text-align: center;
  justify-content: center;

}

.childItem:hover {
  background-color: #F5F7FA;
}
</style>